import { Injectable, inject } from '@angular/core';
import { MessageService as Message } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private message = inject(Message);

  error(message: string) {
    this.message.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000,
    });
  }

  success(message: string) {
    this.message.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
      life: 5000,
    });
  }

  uploading(message: string) {
    this.message.add({
      key: 'uploading',
      sticky: true,
      severity: 'info',
      summary: message,
    });
  }

  clear(key: string) {
    this.message.clear(key);
  }
}
